import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { ModelYhcRegularWorkingDays } from './yhcDataTypes'

type YhcRegularWorkingDaysRecord = ModelYhcRegularWorkingDays & { id?: number }

/**
 * 営業日パターンマスタ
 * - エリア（郵便番号）ごとに異なる営業日の曜日パターンを管理する
 * - 2025/8/15現在: 週7営業(登録なし) / 週6(火定休) / 週4(月水金土) / 週2(木日)
 */
export const yhc_regular_working_days: ModelDef<YhcRegularWorkingDaysRecord> = {
  tableName: 'yhc_regular_working_days',
  tableLabel: '営業日パターンマスタ',
  tableComment: `エリア（郵便番号）ごとに異なる営業日の曜日パターンを管理するマスタ
2025/8/15現在、以下4パターン存在する
- 週7営業 => レコード登録なし
- 週6営業 => 火曜定休
- 週4営業 => 月、水、金、土営業
- 週2営業 => 木、日営業`,
  primaryKeyColType: 'NUMBER',
  columns: {
    pattern_name: {
      type: 'STRING',
      label: 'パターン名',
      bulkEditable: false,
      validate: { notEmpty: true },
    },
    enabled_from: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabled_at: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
    regular_weekdays: {
      type: 'MULTISELECT',
      label: '営業する曜日',
      replicable: true,
      validate: { notEmpty: true },
      inputComponent: 'MultiselectCheckboxesInput',
      selections: () => ['月', '火', '水', '木', '金', '土', '日'],
      width: { xs: 24 },
    },
    fallback_pattern_name: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '例外荷主パターン',
      replicable: true,
      relationshipManyToOne: {
        collectionName: 'yhc_regular_working_days',
        labelFormatter: (row) => row.pattern_name,
      },
    },
  },
}
